// @flow

import React from 'react';
import type { FieldProps } from 'redux-form';
import Error from '../error';
import Input from './input';

/**
 * @todo
 * InputComponent should of course not be typed as any, but as ComponentType<*>.
 * However, since Styled Components does not export a styled component as proper
 * React type, this workaround is necessary.
*/
type OwnProps = {
  className?: string,
  inputComponent?: any,
  placeholder: string,
  type?: string,
  onKeyDown?: Function,
};

type Props = FieldProps & OwnProps;

export default ({
  className = '',
  inputComponent = Input,
  input,
  placeholder,
  meta: {
    touched,
    error,
    valid,
    pristine,
  },
  onKeyDown,
  type = 'text',
}: Props) => {
  const InputComponent = inputComponent;
  return (
    <div className={className}>
      <InputComponent
        {...input}
        placeholder={placeholder}
        error={touched && error}
        valid={touched && !pristine && valid}
        type={type}
        onKeyDown={onKeyDown}
      />
      {touched && error && (<Error message={error} />)}
    </div>
  );
};
